import React, { useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Config from '../Config';
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import moment from 'moment';

function Normaluserview({ id }) {

    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    let navigate = useNavigate();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }

    const [customerdata, setCustomer] = useState([]);
    const [prof, setProf] = useState([]);
    const [enqtoggle, setEnqtoggle] = useState([]);

    const [toggle, setToggle] = useState(false);
    const [blocktoggle, setBlocktoggle] = useState(false);
    const [invitetoggle, setInvitetogg] = useState(false);
    const [projecttoggle, setProjecttogg] = useState(false);
    const [ratingtoggle, setRatingtogg] = useState(false);
    const [reporttoggle, setReporttogg] = useState(false);

    const getinfo = async (e) => {

        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/user/get-user-info/${id}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${Cookies.get("a_token")}`,
                },
            }
        );
        if (res.status === 200) {
            const data = await res.json();

            setCustomer(data.data[0]);

        }
        else if (res.status === 401) {
            handleUnauthorized();
            getinfo();
        }
        else {
            toast.error("Something went wrong!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            <ToastContainer />;
        }
    };

    const getprof = async (e) => {
        const res = await fetch(
            `${Config.apiurl}/api/v1/data/professionals-dropdown`,
            {
                method: "GET",
            }
        );

        const data1 = await res.json();
        const data = data1.data;
        if (res.status === 404 || !data) {
            console.log("error");
        } else {
            setProf(data);
        }
    };

    function handleenqtogg(i) {

        const updatedShowFullData = [...enqtoggle];
        enqtoggle[i].toggle = !enqtoggle[i].toggle;
        setEnqtoggle(updatedShowFullData);
    }

    useEffect(() => {
        getinfo();
        getprof();
    }, []);



    useEffect(() => {


        if (customerdata?.enquiries?.length > 0) {
            const initialState = customerdata?.enquiries?.map((item) => ({

                toggle: Array(item.professionalResponse.length).fill(false),
            }));
            setEnqtoggle(initialState);
        }

    }, [customerdata.length])

    return (
        <>
            <div className='view_page_top'>
                <Link to="/normaluserlist">Normaluser list</Link>
                <Link to={"/editcustomer/" + id}>Edit</Link>
            </div>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Normaluser View page</h4>

                            <div className='row view_div_row'>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Name </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p> {customerdata?.userprofileInfo?.name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Mobile </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p> {"+" + customerdata?.userprofileInfo?.countryCode} {customerdata?.userprofileInfo?.mobile}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Email</h6>
                                        </div>
                                        <div className='view_portion_p_1'>
                                            <p> {customerdata?.userprofileInfo?.email}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6> Location </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {customerdata?.userprofileInfo?.location}</p>
                                        </div>

                                    </div>
                                </div>

                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6> Number of other users block this user </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            {customerdata?.countOfOthersBlockedThisCustomer ?
                                                <p>  {(customerdata?.countOfOthersBlockedThisCustomer[0]?.userCount) ? (customerdata?.countOfOthersBlockedThisCustomer[0]?.userCount) : '0'}</p>
                                                :
                                                <p>0</p>}
                                        </div>

                                    </div>
                                </div>


                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6> Number of other users report this user </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {customerdata?.countOfOthersReportedThisCustomer}</p>
                                        </div>

                                    </div>
                                </div>

                                {customerdata?.userprofileInfo?.profileImage ?
                                    <div className='col-12 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Image </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <img src={customerdata?.userprofileInfo?.profileImage} style={{ width: "100px", height: "100px", marginTop: "10px" }} />
                                            </div>

                                        </div>
                                    </div>
                                    : ""}
                                {/* Blocked user */}
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setBlocktoggle(!blocktoggle)}>
                                            <h6> The professionals list that was blocked by {customerdata?.userprofileInfo?.name} </h6>
                                            {blocktoggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {blocktoggle ?
                                            customerdata.blockedProfiles.length > 0 ?
                                                customerdata.blockedProfiles.map((block, ind) => {
                                                    return (
                                                        <div className='view_portion_p view_response_enq'>
                                                            <div className='row'>
                                                                <div className='col-6 col-md-3'>
                                                                    Name
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.blockedProfileName}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Email
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.blockedProfileEmail}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Phone
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.blockedProfilePhone}</p>

                                                                </div>

                                                                {block.blockedProfileImage ?
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Image
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <img src={block.blockedProfileImage} style={{ width: "100px", height: "100px" }} />

                                                                        </div>
                                                                    </>
                                                                    : ""}

                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <div className='view_portion_p'>
                                                    No Blocked Professionals
                                                </div>
                                            : ""
                                        }
                                    </div>

                                </div>

                                {/* Blocked user end */}

                                {/* Enquiries */}

                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setToggle(!toggle)}>
                                            <h6> Enquiries submited by {customerdata?.userprofileInfo?.name} </h6>
                                            {toggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {toggle ?
                                            customerdata.enquiries.length > 0 ?
                                                customerdata.enquiries.map((enq, i) => {
                                                    return (
                                                        <div className='view_portion_p view_response_enq'>
                                                            <div className='row'>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry ID
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{enq.enquiryId}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry type
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{enq.enquiryType}</p>

                                                                </div>
                                                                {enq.enquiryType === 'Direct-enquiry' ?
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Enquiry Professional
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            {prof.map((prof) => {
                                                                                return (
                                                                                    <>
                                                                                        {prof._id === enq.professional ?
                                                                                            <p> {prof.name}</p>
                                                                                            : ""
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                            }


                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Enquiry Category
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>{enq.enquiryCategoryName}</p>

                                                                        </div>
                                                                    </>
                                                                }


                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Date
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{moment(enq.enquiryDate).utc().format("YYYY-MM-DD")}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Expiry Date
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{moment(enq.enquiryExpiry).utc().format("YYYY-MM-DD")}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Location
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{enq.location}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Requirement
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{enq.requirement}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry status
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{enq.status}</p>

                                                                </div>
                                                                {customerdata.customerdataType === 'Direct-enquiry' && customerdata.professionalResponse?.length > 0 && customerdata?.professionalResponse[0]?.response === false ?
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Professional Reject
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>Yes</p>

                                                                        </div>
                                                                        <div className='col-6 col-md-3'>
                                                                            Rejected Reason
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>{enq.responseText}</p>

                                                                        </div>
                                                                    </>
                                                                    : ""}
                                                                {enq.response === true ?
                                                                    <>

                                                                        <div className='col-6 col-md-3'>
                                                                            Response
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>{enq.responseText}</p>

                                                                        </div>
                                                                    </>
                                                                    : ""}


{/* 
                                                                <div className='col-6 col-md-3'>
                                                                    User Accepted
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    {enq.userAccepted === true ?
                                                                        <p>Yes</p>
                                                                        : <p>No</p>
                                                                    }

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    User Rejected
                                                                </div> */}
                                                                {/* <div className='col-6 col-md-9'>
                                                                    {enq.userReject === true ?
                                                                        <p>Yes</p>
                                                                        : <p>No</p>
                                                                    }
                                                                </div> */}

                                                                <div className='col-12 '>
                                                                    <div className='view_portion'>
                                                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => handleenqtogg(i)}>
                                                                            <h6> Professional Responses </h6>
                                                                            {enqtoggle[i].toggle === true ?
                                                                                <span><IoIosArrowUp /></span>
                                                                                :
                                                                                <span><IoIosArrowDown /></span>
                                                                            }
                                                                        </div>

                                                                        {enqtoggle[i].toggle === true ?
                                                                            enq.professionalResponse.length > 0 ?
                                                                                enq.professionalResponse.map((resp, i) => {
                                                                                    return (
                                                                                        <div className='view_portion_p view_response_enq'>
                                                                                            <div className='row'>

                                                                                                <div className='col-6 col-md-3'>
                                                                                                    Professional
                                                                                                </div>
                                                                                                <div className='col-6 col-md-9'>
                                                                                                    {prof.map((prof, ind) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                {prof._id === resp.professional ?
                                                                                                                    <p> {prof.name}</p>
                                                                                                                    : ""
                                                                                                                }
                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                                </div>
                                                                                                {enq.enquiryType === 'Direct-enquiry' && enq.professionalResponse?.length > 0 && enq?.professionalResponse[0]?.response === false ?
                                                                                                    <>
                                                                                                        <div className='col-6 col-md-3'>
                                                                                                            Professional Reject
                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-9'>
                                                                                                            <p>Yes</p>

                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-3'>
                                                                                                            Rejected Reason
                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-9'>
                                                                                                            <p>{resp.responseText}</p>

                                                                                                        </div>
                                                                                                    </>
                                                                                                    : ""}
                                                                                                {resp.response === true ?
                                                                                                    <>

                                                                                                        <div className='col-6 col-md-3'>
                                                                                                            Response
                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-9'>
                                                                                                            <p>{resp.responseText}</p>

                                                                                                        </div>
                                                                                                    </>
                                                                                                    : ""}



                                                                                                <div className='col-6 col-md-3'>
                                                                                                    User Accepted
                                                                                                </div>
                                                                                                <div className='col-6 col-md-9'>
                                                                                                    {resp.userAccepted === true ?
                                                                                                        <p>Yes</p>
                                                                                                        : <p>No</p>
                                                                                                    }

                                                                                                </div>
                                                                                                <div className='col-6 col-md-3'>
                                                                                                    User Rejected
                                                                                                </div>
                                                                                                <div className='col-6 col-md-9'>
                                                                                                    {resp.userReject === true ?
                                                                                                        <p>Yes</p>
                                                                                                        : <p>No</p>
                                                                                                    }
                                                                                                </div>



                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                                :
                                                                                <div className='view_portion_p'>
                                                                                    No Response found
                                                                                </div>
                                                                            : ""}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className='view_portion_p'>
                                                    No Enquiry found
                                                </div>
                                            : ""}



                                    </div>
                                </div>
                                {/* Enquiries end */}

                                {/* Invited user */}
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setInvitetogg(!invitetoggle)}>
                                            <h6> Invited User Info </h6>
                                            {invitetoggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {invitetoggle ?
                                            customerdata?.invitedUserInfo!==null ?
                                            <div className='view_portion_p view_response_enq'>
                                            <div className='row'>

                                                <div className='col-6 col-md-3'>
                                                    Name
                                                </div>
                                                <div className='col-6 col-md-9'>
                                                   
                                                                    <p> {customerdata?.invitedUserInfo?.name}</p>
                                                                  
                                                </div>

                                                <div className='col-6 col-md-3'>
                                                           Invite ID
                                                        </div>
                                                        <div className='col-6 col-md-9'>
                                                            <p>{customerdata?.invitedUserInfo?.inviteId}</p>

                                                        </div>

                                                        <div className='col-6 col-md-3'>
                                                            Email
                                                        </div>
                                                        <div className='col-6 col-md-9'>
                                                            <p>{customerdata?.invitedUserInfo?.email}</p>

                                                        </div>
                                                        
                                                   <div className='col-6 col-md-3'>
                                                            Mobile
                                                        </div>
                                                        <div className='col-6 col-md-9'>
                                                            <p>{customerdata?.invitedUserInfo?.mobile}</p>

                                                        </div>

                                                        <div className='col-6 col-md-3'>
                                                          Location
                                                        </div>
                                                        <div className='col-6 col-md-9'>
                                                            <p>{customerdata?.invitedUserInfo?.location}</p>

                                                        </div>
                                                
                                            </div>
                                        </div>
                                                : <div className='view_portion_p'>
                                                    No Invite
                                                </div>
                                            : ""
                                        }
                                    </div>

                                </div>

                                {/* Invited user end */}

                                {/* Projects */}
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setProjecttogg(!projecttoggle)}>
                                            <h6> Projects </h6>
                                            {projecttoggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {projecttoggle ?
                                            customerdata?.projects?.length > 0 ?
                                                customerdata.projects.map((block, ind) => {
                                                    return (
                                                        <div className='view_portion_p view_response_enq'>
                                                            <div className='row'>

                                                                <div className='col-6 col-md-3'>
                                                                    Project Name
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.projectName}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry ID
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.enquiryId}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Professional
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.professional}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Project Status
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.projectStatus}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Location
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.location}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Start Date
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{moment(block.startDate).utc().format("YYYY-MM-DD")}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    End Date
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{moment(block.endDate).utc().format("YYYY-MM-DD")}</p>

                                                                </div>




                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <div className='view_portion_p'>
                                                    No Project Available
                                                </div>
                                            : ""
                                        }
                                    </div>

                                </div>
                                {/* project end */}

                                {/* Rating */}
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setRatingtogg(!ratingtoggle)}>
                                            <h6> Rating added by {customerdata?.userprofileInfo?.name} </h6>
                                            {ratingtoggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {ratingtoggle ?
                                            customerdata?.ratingAddedByCustomer?.length > 0 ?
                                                customerdata.ratingAddedByCustomer.map((block, ind) => {
                                                    return (
                                                        <div className='view_portion_p view_response_enq'>
                                                            <div className='row'>

                                                                <div className='col-6 col-md-3'>
                                                                Professional Name
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.professionalName}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Project Name
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.projectName}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Professional Mobile
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.professionalMobile}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Rating
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.rating}</p>

                                                                </div>

                                                                
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <div className='view_portion_p'>
                                                    No Rating List is Available
                                                </div>
                                            : ""
                                        }
                                    </div>

                                </div>
                                {/* Rating end */}

                                  {/* Rating */}
                                  <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setReporttogg(!reporttoggle)}>
                                            <h6> Reporting Professional by {customerdata?.userprofileInfo?.name} </h6>
                                            {reporttoggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {reporttoggle ?
                                            customerdata?.reportedProfiles?.length > 0 ?
                                                customerdata.reportedProfiles.map((block, ind) => {
                                                    return (
                                                        <div className='view_portion_p view_response_enq'>
                                                            <div className='row'>

                                                                <div className='col-6 col-md-3'>
                                                                 Name
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.reportedProfileName}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Email
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.reportedProfileEmail}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                     Mobile
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{block.reportedProfilePhone}</p>

                                                                </div>
                                                                {block?.reportedProfileImage?
                                                                <>
                                                                <div className='col-6 col-md-3'>
                                                                   Image
                                                                </div>

                                                                <div className='col-6 col-md-9'>
                                                                    <img src={block.reportedProfileImage} style={{width:"100px",height:"100px"}} />

                                                                </div>
                                                                </>
                                                                :""}

                                                                
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <div className='view_portion_p'>
                                                    No Reported List is Available
                                                </div>
                                            : ""
                                        }
                                    </div>

                                </div>
                                {/* Report end */}
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </>
    )
}

export default Normaluserview
